module.exports = __webpack_public_path__ + "media/images/badge-welcome-6576b4b58553178fc993f46b171c03e2.svg";